module.exports = __webpack_public_path__ + "assets/images/1zvRg1FY3w.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/Bdd/pages/gznyzyxy/print/image/gznyxylogo.png
// module id = 2196
// module chunks = 0